import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useTranslation, withTranslation} from "react-i18next";
import {questionnaireActions} from "_actions";
import "./informes.scss"
import {history} from "../../../_helpers";
import localOrSessionStore from "../../../_helpers/localOrSessionStore";
import variables from "../../../_constants/variables";
import {useLocation} from "react-router-dom";
import {xcService} from "../../../_services/xcService";
import {isBrowser} from 'react-device-detect';
import Tek4Eso from "./tek/tek4eso";
import Tek3Eso from "./tek/tek3eso";
import Tek1Bac from "./tek/tek1bac";
import Tek2Bac from "./tek/tek2bac";
import TekFPB from "./tek/tekfpb";
import TekFPM from "./tek/tekfpm";
import InformeAllPDF from "./all.pdf.page";
import endpoint from "shared/endpoints";

// eslint-disable-next-line @typescript-eslint/no-var-requires
const _ = require("lodash");

function DownloadInforme(props) {
    const dispatch = useDispatch();
    const storage = localOrSessionStore({key: variables.REMEMBER});
    const {query, search} = useLocation();
    const {t, i18n} = useTranslation();
    const [answers, setAnswers] = useState([]);
    const userType = storage.getItem(variables.USER_TYPE);
    const studentUid = new URLSearchParams(search).get('user');
    const [studentProfile, setStudentProfile] = useState(null);
    const [studentArea, setStudentArea] = useState();
    const [studentAreaCervo, setStudentAreaCervo] = useState();
    const [questionnaires, setQuestionnaires] = useState([]);
    const [userQuest, setUserQuest] = useState();
    const [code, setCode] = useState(null);
    const [course, setCourse] = useState();
    const [timeline, setTimeline] = useState(null);

    const [levels, setLevels] = useState();
    const [studentHistory, setStudentHistory] = useState(null);

    const [answersNoGame3, setAnswersNoGame3] = useState(null);
    const [answersNoGame4, setAnswersNoGame4] = useState(null);
    const [answersNoGame5, setAnswersNoGame5] = useState(null);
    const [answersNoGame6, setAnswersNoGame6] = useState(null);
    const [answersCervo, setAnswersCervo] = useState(null);
    const [answersTek, setAnswersTek] = useState(null);
    const [allLoaded, setAllLoaded] = useState(false)
    const year = +new URLSearchParams(search).get('year');
    const tek = new URLSearchParams(search).get('tek');
    const ceiba = new URLSearchParams(search).get('ceiba');
    const cervo = new URLSearchParams(search).get('cervo');


    const setQuest = async (course) => {
        const quests = {
            '3º ESO': 'TEK3ESO',
            '4º ESO': 'TEK4ESO',
            '1º Bachillerato': 'TEK1BAC',
            '2º Bachillerato': 'TEK2BAC',
            'FP Grado Básico': 'TEKFPB',
            'FP Grado Medio': 'TEKFPM',
        }
        setUserQuest(quests[course])
        const answersPath = userType === 'STUDENT' ? endpoint.studentAnswer.getAll(quests[course], { query: { withResponses: true, year } }) : `/v1/student/${studentUid}/answers/${quests[course]}?withResponses=true&year=${year}`;
        const resp = await xcService.getToken(answersPath);
        setAnswersTek(resp.data.data)

    }

    const codes = {
        '3º ESO': 'TEK3ESO',
        '4º ESO': 'TEK4ESO',
        '1º Bachillerato': 'TEK1BAC',
        '2º Bachillerato': 'TEK2BAC',
        'FP Grado Básico': 'TEKFPB',
        'FP Grado Medio': 'TEKFPM',
    }

    const items1 = {
        '3º ESO': 4,
        '4º ESO': year < 23 ? 6 : 7,
        '1º Bachillerato': 7,
        '2º Bachillerato': 7,
        'FP Grado Básico': 5,
        'FP Grado Medio': 5,
    }

    const items2 = {
        '3º ESO': year < 23 ? 14 : 15,
        '4º ESO': year < 23 ? 13 : 14,
        '1º Bachillerato': 12,
        '2º Bachillerato': 10,
        'FP Grado Básico': 11,
        'FP Grado Medio': 10,
    }
    const items3 = {
        '3º ESO': 8,
        '4º ESO': year < 23 ? 7 : 8,
        '1º Bachillerato': 10,
        '2º Bachillerato': 8,
        'FP Grado Básico': 6,
        'FP Grado Medio': 8,
    }
    var getStudentArea = useSelector((state) => state.questionnaireReducer.getStudentArea);

    useEffect(() => {

        const mUrl = userType === 'STUDENT' ? `/v1/student/course?year=${year}` : `/v1/student/course/${studentUid}?year=${year}`;

        xcService.getToken(mUrl)
            .then(({data}) => {
                setQuest(data.data.name)
                setCourse(data.data.name)
                return data.data.name
            }).then(course => {

                setCode(codes[course])
            }
        );
    }, [])


    const getHistory = () => {
        if (studentUid){
            xcService.getToken(`/v1/${userType === 'STUDENT' ? `student/profile/history/` : `master/${studentUid}/history/`}${year}`)
                .then(({data}) => {
                    setStudentHistory(data.data)
                    let mStudentProfile = studentProfile;

                    setQuest(data.data.course.name);
                    setCourse(data.data.course.name)
                    mStudentProfile.course.id = data.data.course.id;
                    mStudentProfile.course.name = data.data.course.name;
                    setStudentProfile(mStudentProfile);
                })

        }
    }


    useEffect(() => {


        if (studentProfile){

            getHistory(studentUid)


        }

    }, [studentProfile]);

    useEffect(() => {


        if (studentUid && (userType !== 'STUDENT')) xcService.getToken(`/v1/student/${studentUid}/profile`)
            .then(({data}) => {
                setStudentProfile(data.data)

            })
        else {
            //setStudentProfile(localOrSessionStore({key: variables.USER}))

            xcService.getToken('/v1/me').then(({data}) => {

                setStudentProfile(data.data)

            });


        }

    }, [studentUid]);


    const passTen = (value) => {
        if (value <= -2.25) {
            return 0;
        } else {
            if (value > -2.25 && value <= -1.75) {
                return 1
            } else if (value > -1.75 && value <= -1.25) {
                return 2
            } else if (value > -1.25 && value <= -0.75) {
                return 3
            } else if (value > -0.75 && value <= -0.25) {
                return 4
            } else if (value > -0.25 && value <= 0.25) {
                return 5
            } else if (value > 0.25 && value <= 0.75) {
                return 6
            } else if (value > 0.75 && value <= 1.25) {
                return 7
            } else if (value > 1.25 && value <= 1.75) {
                return 8
            } else if (value > 1.75 && value <= 2.25) {
                return 9
            } else {
                return 10
            }
        }
    }

    useEffect(() => {

        dispatch(questionnaireActions.getArea())
        const variablesRequests = [
            'POTENCACAD23',
            'WBACADTOT23',
            'AUTOCONFV23',
            'SWPERTOT23',
            'INFVOCTOT23',
            'MEDIA_NIVEL_ACADEMICO',
            'DESV_NIVEL_ACADEMICO',
            'MEDIA_INFORMACION_VOCA',
            'DESV_INFORMACION_VOCA',
            'MEDIA_AUTOCONFIANZA',
            'DESV_AUTOCONFIANZA',
            'MEDIA_BIENESTAR_ESCOLAR',
            'DESV_BIENESTAR_ESCOLAR',
            'DESV_AUTOCONFIANZA',
            'MEDIA_BIENESTAR_PERSONAL',
            'DESV_BIENESTAR_PERSONAL'
        ].map(variable =>
            xcService.getToken(`/v1/${userType === 'STUDENT' ? 'student' : 'tutor'}/${studentUid}/variable/${variable}?year=${year}`)
        );
        Promise.all(variablesRequests)
            .then(arr => {
                    const res = arr.reduce(
                        (obj, {data}) => ({...obj, ...data.data}),
                        {}
                    )
                    return res;
                }
            )
            .then(vars => {
                setLevels([
                    {
                        name: t("informes.respuestas.tres1"),
                        points: vars.POTENCACAD23 ?
                            vars.POTENCACAD23 : -100,
                        qName: t("informes.pendiente.thistoria")
                    }, {
                        name: t("informes.respuestas.tres2"),
                        points: vars.INFVOCTOT23  ? vars.INFVOCTOT23 : -100,
                        qName: t("informes.pendiente.treflexion")
                    }, {
                        name: t("informes.respuestas.tres3"),
                        points: vars.AUTOCONFV23 ? vars.AUTOCONFV23 : -100,
                        qName: t("informes.pendiente.treflexion")
                    }, {
                        name: t("informes.respuestas.tres4"),
                        points: vars.WBACADTOT23 ? vars.WBACADTOT23 : -100,
                        qName: t("informes.pendiente.tmibienestar")
                    }, {
                        name: t("informes.respuestas.tres5"),
                        points: vars.SWPERTOT23 ? vars.SWPERTOT23 : -100,
                        qName: t("informes.pendiente.tmibienestar")
                    },
                ])
            })
    }, []);

    const getAll = async () => {

        const questionPath = userType === 'STUDENT' ? `/v1/student/myquestionnaires?year=${year}` : `/v1/student/${studentUid}/questionnaires?year=${year}`;
        xcService.getToken(questionPath).then(async ({data}) => {

            setQuestionnaires(data.data)
            let mNoGame3 = _.filter(
                data.data, function (o) {
                    return o.code === 'NOGAM3';
                }
            );
            if (mNoGame3 && mNoGame3[0] && mNoGame3[0].totresp === mNoGame3[0].tota) {
                const mUrl = userType === 'STUDENT' ? endpoint.studentAnswer.getAll('NOGAM3', { query: { withResponses: true, year } }) : `/v1/student/${studentUid}/answers/NOGAM3?withResponses=true&year=${year}`;
                await xcService.getToken(mUrl).then(({data}) =>
                    setAnswersNoGame3(data.data));

            }



            let mTemp = _.filter(
                data.data, function (o) {
                    return o.code === 'NOGAM4';
                }
            );
            if (mTemp && mTemp[0] && mTemp[0].totresp === mTemp[0].tota) {
                const mUrl =userType === 'STUDENT' ? endpoint.studentAnswer.getAll('NOGAM4', { query: { withResponses: true, year } }) : `/v1/student/${studentUid}/answers/NOGAM4?withResponses=true&year=${year}`;

                xcService.getToken(mUrl).then(({data}) =>
                    setAnswersNoGame4(data.data));
            }


            mTemp = _.filter(
                data.data, function (o) {
                    return o.code === 'NOGAM5';
                }
            );
            if (mTemp && mTemp[0] && mTemp[0].totresp === mTemp[0].tota) {
                const mUrl =userType === 'STUDENT' ? endpoint.studentAnswer.getAll('NOGAM5', { query: { withResponses: true, year } }) : `/v1/student/${studentUid}/answers/NOGAM5?withResponses=true&year=${year}`;

                xcService.getToken(mUrl).then(({data}) =>
                    setAnswersNoGame5(data.data));
            }


            mTemp = _.filter(
                data.data, function (o) {
                    return o.code === 'NOGAM6';
                }
            );
            if (mTemp && mTemp[0] && mTemp[0].totresp === mTemp[0].tota) {
                const mUrl =userType === 'STUDENT' ? endpoint.studentAnswer.getAll('NOGAM6', { query: { withResponses: true, year } }) : `/v1/student/${studentUid}/answers/NOGAM6?withResponses=true&year=${year}`;
                xcService.getToken(mUrl).then(({data}) =>
                    setAnswersNoGame6(data.data));
            }


            let mCervo = _.filter(
                data.data, function (o) {
                    return o.code === 'CERVO';
                }
            );
            if (mCervo && mCervo[0] && mCervo[0].totresp === mCervo[0].tota) {
                const mUrl = userType === 'STUDENT' ? endpoint.studentAnswer.getAll('CERVO', { query: { withResponses: true, year } }) : `/v1/student/${studentUid}/answers/CERVO?withResponses=true&year=${year}`;

                await xcService.getToken(mUrl).then(({data}) =>
                    setAnswersCervo(data.data));
            }


            let mTek = _.filter(
                data.data, function (o) {
                    return o.code === code;
                }
            );

            if (mTek && mTek[0] && mTek[0].totresp === mTek[0].tota) {
                const mUrl = userType === 'STUDENT' ? endpoint.studentAnswer.getAll(code, { query: { withResponses: true, year } }) : `/v1/student/${studentUid}/answers/${code}?withResponses=true&year=${year}`;


                await xcService.getToken(mUrl).then(({data}) =>
                    setAnswersTek(data.data));
            }


            const answersPath = userType === 'STUDENT' ? endpoint.studentAnswer.getAll('CEIBA', { query: { year } }) : `/v1/student/${studentUid}/answers/CEIBA?year=${year}`;
            await  xcService.getToken(answersPath).then(({data}) => setAnswers(data.data));
            const areaPath = userType === 'STUDENT' ? `/v1/student/area/CEIBA?year=${year}` : `/v1/student/${studentUid}/area/CEIBA?year=${year}`
            await xcService.getToken(areaPath).then(({data}) => setStudentArea(data.data));

            const areaCevoPath = userType === 'STUDENT' ? `/v1/student/area/CERVO?year=${year}` : `/v1/student/${studentUid}/area/CERVO?year=${year}`
            await xcService.getToken(areaCevoPath).then(({data}) => setStudentAreaCervo(data.data));

            setAllLoaded(true);
        })

    }

    useEffect(() => {
        if (code )
        getAll()

    }, [code]);

    return (
            <div className={"container dasboard-informes"}>
                {isBrowser ? <></> : <></>}
                <div style={{
                    width: "100%", height: "100%", paddingTop: `${isBrowser ? "calc(1%)" : "calc(15%)"}`, paddingLeft: `${isBrowser ? "calc(1%)" : "calc(25%)"}`
                }}>

            <>

                {studentProfile && answersTek?.length > 0 && userQuest === "TEK4ESO" &&
                    <Tek4Eso forDownload={true}  setTimeline={setTimeline} answers={answersTek} studentProfile={studentProfile}/>
                }
                {studentProfile && answersTek?.length > 0 && userQuest === "TEK3ESO" &&
                    <Tek3Eso  forDownload={true}  setTimeline={setTimeline} answers={answersTek} studentProfile={studentProfile}/>
                }
                {studentProfile && answersTek?.length > 0 && userQuest === "TEK1BAC" &&
                    <Tek1Bac  forDownload={true}  setTimeline={setTimeline} answers={answersTek} studentProfile={studentProfile}/>
                }
                {studentProfile && answersTek?.length > 0 && userQuest === "TEK2BAC" &&
                    <Tek2Bac forDownload={true}  setTimeline={setTimeline} answers={answersTek} studentProfile={studentProfile}/>
                }
                {studentProfile && answersTek?.length > 0 && userQuest === "TEKFPB" &&
                    <TekFPB  forDownload={true}  setTimeline={setTimeline} answers={answersTek} studentProfile={studentProfile}/>
                }
                {studentProfile && answersTek?.length > 0 && userQuest === "TEKFPM" &&

                    <TekFPM  forDownload={true}  setTimeline={setTimeline} answers={answersTek} studentProfile={studentProfile}/>
                }


                {studentProfile && studentHistory &&

                    <InformeAllPDF forDownload={isBrowser ? true : false}
                                   style={{marginBottom: 15}}
                                   ceiba={ceiba} cervo={cervo} tek={tek}
                                   props={props} studentProfile={studentProfile}
                                   getStudentArea={getStudentArea}
                                   answersNoGame3={answersNoGame3}
                                   answersCervo={answersCervo}
                                   answersTek={answersTek}
                                   items1={items1}
                                   code={code}
                                   items2={items2}
                                   items3={items3}
                                   studentAreaCervo={studentAreaCervo}
                                   answers={answers}
                                   course={course}
                                   studentArea={studentArea}
                                   levels={levels}
                                   answersNoGame4={answersNoGame4}
                                   studentHistory={studentHistory}
                                   answersNoGame5={answersNoGame5}
                                   answersNoGame6={answersNoGame6}
                                   timeline={timeline}
                    />
                }



            </>
            </div>
        </div>
    )
}

export default withTranslation()(DownloadInforme);


